export const summitexitososinnpolizas = {
    error: false,
    data: {
        leadId: "00Qdq0000019bPZEAY",
        owner: false,
        errorCode: "INVOKE-200",
        error: "OK"
    }
};

export const summitexitosoconmasdenpolizas = {
    error: false,
    data: {
        leadId: "00Qdq0000019bPZEAY",
        cuantity: 16,
        owner: true,
        errorCode: "INVOKE-200",
        error: "OK"
    }
};

// Consulta de riesgos - pasa riesgos
export const consultaRiesgoPasa = {
    error: false,
    leadId: "00Qdq0000019bPZEAY",
    asesorCode: "12345",
    bitacoraId: "4AS42ZSDD00010A0A1",
    ConsultaRiesgo: {
        error: "OK",
        success: true
    },
    data: [
        {
            idRegistroValidacion: "692f95d3-ed3e-4754-bfa0-b69777a4fd26",
            mensajeValidacion: "",
            tipoValidacion: "N",
            esRiesgo: false
        },
        {
            idRegistroValidacion: "a87f19cd-4cba-4ad2-be43-b0306f795325",
            mensajeValidacion: "",
            tipoValidacion: "N",
            esRiesgo: false
        }
    ]
};

// Consulta de riesgos - propietario no pasa
export const consultaRiesgoPropietarioNoPasa = {
    error: false,
    leadId: "00Qdq0000019bPZEAY",
    asesorCode: "12345",
    bitacoraId: "4AS42ZSDD00010A0A1",
    ConsultaRiesgo: {
        error: "OK",
        success: true
    },
    data: [
        {
            idRegistroValidacion: "ff58f87c-02b9-4471-86fd-577e92e3fce6",
            mensajeValidacion: "El tomador es un riesgo no es estandar y no puede ser atendido por este canal. Comuníquese con su gerente o director",
            tipoValidacion: "B",
            esRiesgo: true
        },
        {
            idRegistroValidacion: "49e6f63d-4339-42e0-b0d4-6c38489d424b",
            mensajeValidacion: "",
            tipoValidacion: "N",
            esRiesgo: false
        }
    ]
};

// Consulta de riesgos - inquilino no pasa
export const consultaRiesgoInquilinoNoPasa = {
    error: false,
    leadId: "00Qdq0000019bPZEAY",
    asesorCode: "12345",
    bitacoraId: "4AS42ZSDD00010A0A1",
    ConsultaRiesgo: {
        error: "OK",
        success: true
    },
    data: [
        {
            idRegistroValidacion: "4ecd3148-86d3-4e60-b83b-ea5950c25fcd",
            mensajeValidacion: "",
            tipoValidacion: "N",
            esRiesgo: false
        },
        {
            idRegistroValidacion: "34010239-d1b7-4f6f-9164-1e8d5b1ea9ef",
            mensajeValidacion: "El Afianzado es un riesgo no estándar y no puede ser atendido por este canal. Comuníquese con su gerente o director",
            tipoValidacion: "B",
            esRiesgo: true
        }
    ]
};

// Falla servicio de riesgos
export const consultaRiesgoFallaServicio = {
    error: true,
    leadId: "00Qdq0000019bPZEAY",
    bitacoraId: "00Qdq0000019bPZE12",
    message: "Error al consultar el servicio de riesgos consultables"
};
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
						
					
					
					
					
					
					
					
					
					
					
					